import { useEffect, useState } from 'react';

export interface Viewport {
  vw: number;
  isMobile: boolean; // phone < 720
  isTablet: boolean; // 720 ≤ vw < 1024
  isCompact: boolean; // < 1100 — hide non-essential top-nav chrome
  isNarrow: boolean; // < 1280
}

export function useViewport(): Viewport {
  const [vw, setVw] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280);
  useEffect(() => {
    let raf = 0;
    function onResize() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setVw(window.innerWidth));
    }
    window.addEventListener('resize', onResize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', onResize);
    };
  }, []);
  return {
    vw,
    isMobile: vw < 720,
    isTablet: vw >= 720 && vw < 1024,
    isCompact: vw < 1100,
    isNarrow: vw < 1280,
  };
}
